__turbopack_context__.v({
  "navigation-tab": "bzgS_G_navigation-tab",
  "navigation-tab--active": "bzgS_G_navigation-tab--active",
  "navigation-tab--focus-visible": "bzgS_G_navigation-tab--focus-visible",
  "navigation-tab__check-icon": "bzgS_G_navigation-tab__check-icon",
  "navigation-tabs-container": "bzgS_G_navigation-tabs-container",
  "navigation-tabs-container--expanded": "bzgS_G_navigation-tabs-container--expanded",
  "navigation-tabs-container__expand-button": "bzgS_G_navigation-tabs-container__expand-button",
  "navigation-tabs-container__expand-button--skeleton": "bzgS_G_navigation-tabs-container__expand-button--skeleton",
  "navigation-tabs-container__expand-button-caret": "bzgS_G_navigation-tabs-container__expand-button-caret",
  "navigation-tabs-container__tabs-list": "bzgS_G_navigation-tabs-container__tabs-list",
  "navigation-tabs-content": "bzgS_G_navigation-tabs-content",
  "navigation-tabs-wrapper": "bzgS_G_navigation-tabs-wrapper",
});
